module.exports = __webpack_public_path__ + "img/casino-roulette.b2da6372.png";